import {
    take,
    put,
    call,
    all,
    takeEvery,
} from 'redux-saga/effects';
import { financialYearActions as actions, notificationActions } from '../actions';
import { financialYearService } from '../services';

/* Add FinancialYear */
function* handleAddFinancialYearRequest() {
    const action = yield take(actions.addFinancialYearRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(financialYearService.addFinancialYear, dataParams)
        if (res.isError) {
            yield put(actions.addFinancialYearError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addFinancialYearSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addFinancialYearError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Department */
function* handleGetAllFinancialYearRequest() {
    const action = yield take(actions.getAllFinancialYearRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(financialYearService.getAllFinancialYear, dataParams);

        if (res.isError) {
            yield put(actions.getAllFinancialYearError(res));

        } else {
            yield put(actions.getAllFinancialYearSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllFinancialYearError());
    }
}


/* Update FinancialYear */
function* handleUpdateFinancialYearRequest() {
    const action = yield take(actions.updateFinancialYearRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(financialYearService.updateFinancialYear, dataParams);
        if (res.isError) {
            yield put(actions.updateFinancialYearError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateFinancialYearSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateFinancialYearError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/*Get Financial Year List */
function* handleGetFinancialYearListRequest() {
    const action = yield take(actions.getFinancialYearListRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(financialYearService.getFinancialYearList, dataParams);
        if (res.isError) {
            yield put(actions.getFinancialYearListError(res));
        } else {
            yield put(actions.getFinancialYearListSuccess(res));
        }
    } catch (error) {
        yield put(actions.getFinancialYearListError());
    }
}


/*Get Financial Year List */
function* handleGetFinancialYearWiseMonthRequest() {
    const action = yield take(actions.getFinancialYearWiseMonthRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(financialYearService.getFinancialYearWiseMonth, dataParams);
        if (res.isError) {
            yield put(actions.getFinancialYearWiseMonthError(res));
        } else {
            yield put(actions.getFinancialYearWiseMonthSuccess(res));
        }
    } catch (error) {
        yield put(actions.getFinancialYearWiseMonthError());
    }
}


/* -----------Watchers-------------*/
function* handleAddFinancialYearWatcher() {
    yield takeEvery(
        actions.addFinancialYearRequest,
        handleAddFinancialYearRequest,
    );
}

function* handleGetAllFinancialYearWatcher() {
    yield takeEvery(
        actions.getAllFinancialYearRequest,
        handleGetAllFinancialYearRequest,
    );
}

function* handleUpdateFinancialYearWatcher() {
    yield takeEvery(
        actions.updateFinancialYearRequest,
        handleUpdateFinancialYearRequest,
    );
}

function* handleGetFinancialYearListWatcher() {
    yield takeEvery(
        actions.getFinancialYearListRequest,
        handleGetFinancialYearListRequest,
    );
}

function* handleGetFinancialYearWiseMonthWatcher() {
    yield takeEvery(
        actions.getFinancialYearWiseMonthRequest,
        handleGetFinancialYearWiseMonthRequest,
    );
}


function* rootFinancialYearSaga() {
    yield all([
        handleAddFinancialYearRequest(),
        handleAddFinancialYearWatcher(),

        handleGetAllFinancialYearRequest(),
        handleGetAllFinancialYearWatcher(),

        handleUpdateFinancialYearRequest(),
        handleUpdateFinancialYearWatcher(),

        handleGetFinancialYearListRequest(),
        handleGetFinancialYearListWatcher(),

        handleGetFinancialYearWiseMonthRequest(),
        handleGetFinancialYearWiseMonthWatcher(),
    ]);
}

export default rootFinancialYearSaga;
